// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Column from '../../components/Column';
import LoadingIcon from '../../components/LoadingIcon';
import Footer from '../../layouts/MainLayout/Footer';

const S = {
  LoginFormContainer: styled.div`
    margin-top: 38px;
    height: 100%;
  `,
  Logo: styled.img`
    height: 16px;
    width: 115px;
  `,
  Container: styled(Column)`
    height: 100%;
    width: 100%;
  `,
  HeaderContainer: styled(Column)`
    align-items: center;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    margin-top: 15px;
    margin-bottom: 9px;
  `,
  SubTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
  `,
  LoadingAnimation: styled(LoadingIcon).attrs({ size: 20, contentOrientation: 'center'})``,
  LoadingWrapper: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
    flex-direction: column;
  `,
  LoadingContainer: styled.div`
    display: flex;
    flex-grow: 1;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  `,
  LoadingText: styled.p`
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
    margin-left: 10px;
  `,
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.31);
  `,
  Header: styled.header`
    display: flex;
    align-items: stretch;
    width: 100%;
    height: 70px;
    padding: 0 37px;
    background-color: #313131;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
  `,
  HeaderLogo: styled.img`
    align-self: center;
    width: 186px;
    margin-right: 18px;
  `,
  ErrorBody: styled.div`
  height: 100%;
  display: block;
  `,
  Footer: styled(Footer)`
    margin-top: auto;
  `,
};

export { S as default }
